import * as React from "react";
import { Page } from "_core/components";
import { Charger, ProductUrls } from "_core/types";
import { useStore } from "_core/store";
import { HypervoltChargerCustomisation } from "./Hypervolt/HypervoltChargerCustomisation";
import { IndraChargerCustomisation } from "./Indra/IndraChargerCustomisation";
import { AndersenA2ChargerCustomisation } from "./Andersen/AndersenA2ChargerCustomisation";
import { AndersenA3ChargerCustomisation } from "./Andersen/AndersenA3ChargerCustomisation";
import { AndersenQuartzChargerCustomisation } from "./Andersen/AndersenQuartzChargerCustomisation";
import { Zappi21ChargerCustomisation } from "./MyEnergi/Zappi21ChargerCustomisation";
import { NoChargerCustomisation } from "./NoCustomisation/NoCustomisation";

const chargerComponentMap: Partial<Record<Charger, React.ComponentType>> = {
  [Charger.HYPERVOLT]: HypervoltChargerCustomisation,
  [Charger.INDRA]: IndraChargerCustomisation,
  [Charger.ANDERSENA2]: AndersenA2ChargerCustomisation,
  [Charger.ANDERSENA3]: AndersenA3ChargerCustomisation,
  [Charger.ANDERSENQUARTZ]: AndersenQuartzChargerCustomisation,
  [Charger.ZAPPI21]: Zappi21ChargerCustomisation,
};

export const ChargerCustomisationPage = () => {
  const { charger } = useStore();

  const ChargerCustomisationComponent =
    (charger && chargerComponentMap[charger]) ?? NoChargerCustomisation;

  return (
    <Page
      displaySteps
      title=""
      subtitle=""
      url={ProductUrls.ChargerCustomisation}
    >
      <ChargerCustomisationComponent />
    </Page>
  );
};
